module.exports = __webpack_public_path__ + "img/ネタツイ_0226030909.45aa46f8.png";